import type { Route } from "next";

import { SocialsEnum } from "@rivval/utils";

import { env } from "~/env.mjs";
import type { SiteConfig } from "~/types";
import { siteRoutes } from "~/types/enum";

export const siteConfig: SiteConfig = {
  name: "RIVVAL LTD",
  description:
    "RIVVAL LTD is a company that provides innovative solutions for the rail industry.",
  url: `https://www.rivval.com`,
  links: {
    twitter: SocialsEnum.twitter,
  },
};

export const companyDetails = [
  {
    address:
      "RIVVAL LTD, Drumconrath Rd,, Carrickasedge, Carrickmacross, Co. Monaghan, A81DV25, Ireland",
    phone: "+353 (0)42 9690882",
    email: "sales@rivval.com",
    vat: "IE6410186G",
    openingHours:
      "Mon: 8:30 - 17:00. Tues - Thurs: 8:00 - 17:00. Fri: 8:00 - 15:00",
    weee: "IE01340W",
  },
];

export const FOOTER_NAVIGATION = [
  {
    name: "Facebook",
    href: SocialsEnum.facebook,
    icon: "Facebook",
  },
  {
    name: "LinkedIn",
    href: SocialsEnum.linkedin,
    icon: "LinkedIn",
  },
  {
    name: "YouTube",
    href: SocialsEnum.youtube,
    icon: "YouTube",
  },
];

interface NavItem {
  href: Route;
  title: string;
  description?: string;
  backgroundImage?: string;
  subNav?: NavItem[];
}

export const DESKTOP_NAV: NavItem[] = [
  {
    title: "About",
    href: `${siteRoutes.About}`,
  },
  {
    title: "Products",
    href: `${siteRoutes.Categories}`,
  },
  {
    title: "Projects",
    href: `${siteRoutes.Projects}`,
    subNav: [
      {
        title: "Project History",
        href: `${siteRoutes.Projects}`,
        description: "Overview of railway infrastructure projects",
        backgroundImage: `${env.NEXT_PUBLIC_ASSETS_URL}/images/storefront/projects/project-1.jpg`,
      },

      {
        title: "Elevated Troughing",
        href: `${siteRoutes.ElevatedTroughing}`,
        description: "Upcoming projects and railway innovations",
      },
    ],
  },

  {
    title: "Contact",
    href: `${siteRoutes.Contact}`,
  },
];

export const MOBILE_NAV = [
  {
    href: `${siteRoutes.About}`,
    title: "About",
  },

  {
    href: `${siteRoutes.Products}`,
    title: "Products",
  },

  {
    href: `${siteRoutes.Projects}`,
    title: "Projects",
  },

  {
    href: `${siteRoutes.Capabilities}`,
    title: "Capabilities",
  },

  {
    href: `${siteRoutes.Contact}`,
    title: "Contact Us",
  },
] satisfies {
  href: Route;
  title: string;
}[];
